<div class="dialog-header" data-testid="filetypes-guide-dialog">
  <h3 mat-dialog-title class="dialog-title">
    Guide to filetypes and translation assets
  </h3>
  <button
    class="close-x"
    (click)="close()"
    aria-label="Close dialog"
    data-testid="filetypes-guide-close-btn"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M6.36436 19.0588L4.96436 17.6588L10.5644 12.0588L4.96436 6.45884L6.36436 5.05884L11.9644 10.6588L17.5644 5.05884L18.9644 6.45884L13.3644 12.0588L18.9644 17.6588L17.5644 19.0588L11.9644 13.4588L6.36436 19.0588Z"
        fill="white"
      />
    </svg>
  </button>
</div>

<mat-dialog-content class="dialog-body">
  <p class="dialog-intro">We support the following files:</p>

  <ul class="filetypes-list">
    <li>
      <strong>Source files (preferred):</strong> docx, xlsx, pptx, csv, dita,
      pot, idml (InDesign), html, xml, json, yaml/yml, xlf/xliff (v1.x), txt,
      md/ markdown, strings, stringsdict, properties, resx, resw, ts
    </li>
    <li>
      <strong>PDFs:</strong> PDFs are supported, but
      <strong>please upload the original source file</strong> when possible for
      better results.
    </li>
    <li>
      <strong>E‑learning (SCORM):</strong> Supported. To ensure proper
      translation, you must upload either an XLIFF file or an HTML file. If
      built in Articulate Storyline or Adobe Captivate: ask your production
      partner for an XLIFF file or a Word document.
    </li>
    <li>
      <strong>Illustrator (AI):</strong> Supported on an exception basis. Please
      <a href="mailto:aztranslate@astrazeneca.com" class="email-link"
        >contact support.</a
      >
    </li>
  </ul>
</mat-dialog-content>
